import { Avatar } from "@chakra-ui/react";

const CustomAvatar = ({
  name,
  src,
  size,
}: {
  size?: "sm" | "md" | "lg" | "xl" | "2xl" | "full" | "2xs" | "xs";
  name?: string;
  src?: string;
}) => {
  return (
    <Avatar.Root size={size}>
      <Avatar.Fallback name={name} />
      <Avatar.Image src={src} />
    </Avatar.Root>
  );
};

export default CustomAvatar;
